import { useEffect } from 'react';
export function useClickOutside(elementRef, fn, active = true) {
    useEffect(() => {
        const listener = (e) => {
            var _a, _b;
            const element = elementRef && 'current' in elementRef ? elementRef.current : elementRef;
            if (e.detail === 0 ||
                !active ||
                !element ||
                ((_a = e.composedPath) === null || _a === void 0 ? void 0 : _a.call(e).includes(element)) ||
                element.contains(e.target) ||
                ((_b = e.target) === null || _b === void 0 ? void 0 : _b.tagName.toLowerCase().indexOf('1password')) !== -1) {
                return;
            }
            fn(e);
        };
        /*
         * delay the subscription so the click does not trigger immediately when the element is created
         * https://github.com/facebook/react/issues/24657#issuecomment-1150119055
         */
        const timeoutId = setTimeout(() => {
            document.addEventListener('click', listener);
        }, 0);
        return () => {
            clearTimeout(timeoutId);
            setTimeout(() => {
                document.removeEventListener('click', listener);
            }, 0);
        };
    }, [elementRef, fn, active]);
}
//# sourceMappingURL=useClickOutside.js.map